import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class FollowUpsListModel extends BaseModel {
  @attr("string") header;
  @attr("string") internalName;
  @attr("string") name;
  @attr("string") uuid;
}
